webpackJsonp([200084577921036],{

/***/ 284:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/contacts-1.8f827db5.svg";

/***/ }),

/***/ 1100:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/reviews-1.a4767a36.svg";

/***/ }),

/***/ 472:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _classCallCheck2 = __webpack_require__(4);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _possibleConstructorReturn2 = __webpack_require__(6);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(5);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(8);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _reactHelmet = __webpack_require__(11);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _navigation = __webpack_require__(13);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _footer = __webpack_require__(12);
	
	var _footer2 = _interopRequireDefault(_footer);
	
	var _reviews = __webpack_require__(1100);
	
	var _reviews2 = _interopRequireDefault(_reviews);
	
	var _contacts = __webpack_require__(284);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _registerNowLeft = __webpack_require__(23);
	
	var _registerNowLeft2 = _interopRequireDefault(_registerNowLeft);
	
	var _cover = __webpack_require__(19);
	
	var _cover2 = _interopRequireDefault(_cover);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Reviews = function (_React$Component) {
		(0, _inherits3.default)(Reviews, _React$Component);
	
		function Reviews() {
			(0, _classCallCheck3.default)(this, Reviews);
			return (0, _possibleConstructorReturn3.default)(this, _React$Component.apply(this, arguments));
		}
	
		Reviews.prototype.pageClick = function pageClick(e) {
			document.getElementsByTagName('body')[0].className = '';
		};
	
		Reviews.prototype.fixedSidebar = function fixedSidebar() {
	
			var sidebar = document.getElementById('sidebar'),
			    sidebar_scroll = document.getElementById('sidebar-scroll'),
			    content = document.getElementById('content');
			var scrTop = window.pageYOffset,
			    formOuterH = getAbsoluteHeight(sidebar_scroll),
			    formH = sidebar_scroll.clientHeight,
			    contentH = content.clientHeight,
			    contentOfTop = getElementTop(content),
			    sidebarH = sidebar.clientHeight,
			    sidebarOfTop = getElementTop(sidebar),
			    contentB = contentH + contentOfTop;
	
			if (window.innerHeight > 767) {
				if (contentH > sidebarH + formOuterH) {
					sidebar_scroll.parentNode.setAttribute('style', 'min-height:' + formOuterH + 'px');
					if (scrTop >= sidebarOfTop - 70) {
						sidebar_scroll.setAttribute('data-fixed', true);
	
						if (contentB < scrTop + formH + 70) {
							sidebar_scroll.setAttribute('style', 'top:' + -(scrTop + formH - contentB) + 'px');
						} else {
							sidebar_scroll.setAttribute('style', 'top:70px');
						}
					} else {
						sidebar_scroll.setAttribute('style', 'top:auto');
						sidebar_scroll.removeAttribute('data-fixed');
					}
				}
			}
	
			function getElementTop(e) {
				for (var t = e.offsetTop, a = e.offsetParent; null != a;) {
					t += a.offsetTop, a = a.offsetParent;
				}return t;
			}
	
			function getAbsoluteHeight(t) {
				t = "string" == typeof t ? document.querySelector(t) : t;var e = window.getComputedStyle(t),
				    o = parseFloat(e.marginTop) + parseFloat(e.marginBottom);return Math.ceil(t.offsetHeight + o);
			}
		};
	
		Reviews.prototype.componentDidMount = function componentDidMount() {
			var mask = document.getElementById('mask');
			mask.addEventListener('touchstart', this.pageClick, false);
			this.fixedSidebar;
	
			window.addEventListener('scroll', this.fixedSidebar, false);
	
			window.addEventListener('resize', this.fixedSidebar, false);
		};
	
		Reviews.prototype.componentWillUnmount = function componentWillUnmount() {
			window.removeEventListener('scroll', this.fixedSidebar);
			window.removeEventListener('resize', this.fixedSidebar);
		};
	
		Reviews.prototype.render = function render() {
			return _react2.default.createElement(
				"div",
				null,
				_react2.default.createElement(_reactHelmet2.default, {
					title: "UVOCorp.com - Writers' Reviews. What People Say About UvoCorp.com - UvoCorp.com",
					meta: [{ name: "description", content: "What writers say about writing job at UvoCorp.com. Real writers' reviews about UvoCorp.com" }, { property: 'og:title', content: "UVOCorp.com - Writers' Reviews. What People Say About UvoCorp.com - UvoCorp.com" }, { property: 'og:description', content: "What writers say about writing job at UvoCorp.com. Real writers' reviews about UvoCorp.com" }, { property: 'og:site_name', content: "UvoCorp.com" }, { property: 'og:type', content: "website" }, { property: 'og:image', content: _cover2.default }],
					link: [{ rel: 'canonical', href: "https://www.uvocorp.com/reviews.html" }] }),
				_react2.default.createElement(
					"div",
					{ className: "header", id: "header" },
					_react2.default.createElement(_navigation2.default, null)
				),
				_react2.default.createElement(
					"div",
					{ className: "wrapper" },
					_react2.default.createElement(
						"div",
						{ className: "inner-header" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h1",
								null,
								"Reviews"
							),
							_react2.default.createElement(
								_gatsbyLink2.default,
								{ to: "/register_email.html" },
								"Register now"
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-white" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"h2",
								{ className: "left" },
								"We asked our writers to share their opinion about uvocorp.com. ",
								_react2.default.createElement(
									"span",
									{ className: "reviews-subtitle" },
									"Check what they think about our service."
								)
							),
							_react2.default.createElement(
								"div",
								{ id: "content", className: "col-md-8" },
								_react2.default.createElement(
									"ul",
									{ className: "reviews" },
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #28789*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in April 2016"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"Working with UVOCORP is very beneficial and encouraging"
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #23268*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in February 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"Working with Uvocorp gives a sense of fulfillment."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #2333*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in November 2010"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"Working with this company is fantastic. It is highly motivating."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #30105*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in March 2017"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"Working with this company has been beneficial. I would recommend it to a friend."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #352*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in June 2009"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"Uvocorp has proven to be very professional and I would encourage potential writers to join"
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #28940*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in February 2017"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"Uvo is the best agency I have worked in. I have already recommended UVO to some of my friends. I have no negative remarks. "
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #28689*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in March 2016"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The cooperation with the company is excellent and encouraging"
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #24366*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in March 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The company is a great chance have a good money for interesting and fascinating work from all parts of the world."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #29529*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in October 2016"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The company has been encouraging me a lot and I feel part of the team. I would not hesitate  to recommend the company to other professional writers out there to join the great team."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #26934*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in August 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The company avail much needed cooperation which motivate the writer to deliver high quality work on orders"
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #28119*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in November 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The best company to work with. "
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #30128*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in March 2017"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The benefits still outweigh few negative experiences I've had."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #27449*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in August 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"Uvocorp is the best company for hardworking freelancers."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #328*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in April 2009"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"My response would be that you are a company that rewards the efforts of writers without hesitation since you value their input. I would also enumerate the unrivaled advantages/benefits of working as a writer for Uvocorp."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item", id: "28612*" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #28612*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in March 2016"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"It's very beneficial to work with you! Although more legal orders would be nice to have, in general Uvo corp is a must for both people that are beginners in remote writing! It also accommodates experienced writers very well. You are very consistent with everything written in the FAQs. Your system is easy to learn, and you should only keep doing what you were doing, but always have an ear for improvement. In short, you are professionals that take this job seriously and I hope you continue like that!"
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #28728*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in March 2016"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"It is very beneficial working with the company, I would encourage my friends to join the company. You provide the best services in this industry."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item", id: "26272*" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #26272*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in August 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"It is very beneficial to work with the company. There is a constant flow of orders for the most part of the year, the payment department is fast, efficient, and supports several payment methods and the support team as well as company regulations are excellent, easy to work with, and foster professionalism. "
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #18598*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in January 2014"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"It is very beneficial to work with the company. The company takes the interest of both the writers and the customers seriously. I particularly like how arising cases are handled by the departments."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item", id: "25570*" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #25570*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in August 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"It is GREAT! I love working with you, I can be ill and still not discouraged because of it, I can be at a remote location, but still have an opportunity to finish assignments, which means for me advancing of my skills and flourishing of my vocabulary! I also feel that I can help those who need assistance."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #29684*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in December 2016"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"I've already recommended UvoCorp to several of my friends, and even encouraged them to write to the recruiting dept. directly while the registrations were closed. So far, I've had nothing but good experience working with UvoCorp (great pay + awesome mentor - kudos to Julia Blade + great support) - why not spread the good word?"
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item", id: "12810*" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #12810*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in May 2013"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"I find UVOCORP as a highly professional site for freelance writers. I appreciate and am grateful to be part of this company in more than three years now. I'm looking forward to continuously working with you and witness all improvements and progress."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #22975*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in February 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"It was a great season! Thank you for cooperation and support!"
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #27219*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in August 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"Taking this opportunity, I want to say a great thank you to our service. Thanks to you I found job of my dream. Thank you for your reliability, honesty and gratitude to your writers!"
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #1184*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in May 2010"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"Thank you for the continued improvement. I feel more satisfied as a writer."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #27415*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in August 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The bonus system is currently working well. The calculations are fair and they motivate towards working hard and be more precise in handling of orders to ensure ultimate customer satisfaction."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #27796*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in August 2015"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The bonus system is superb. In fact, it is more effective than the previous one which was more of quantitative."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #28903*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in May 2016"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The bonus system is understandable and clear, it gives motivation to focus on a number of aspects and thus contributes to the development not only in quantitative terms (number of pages), but in qualitative too (the content as it is)."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #18262*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in December 2013"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The bonus system is very encouraging"
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #18598*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in January 2014"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The bonus system is very good since it looks at all the aspects of quality. It has made me work even better on my orders with an aim of getting a bonus on all criteria."
											)
										)
									),
									_react2.default.createElement(
										"li",
										{ className: "reviews-item" },
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-header" },
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-rating" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-title" },
													"Writer's estimate: "
												),
												_react2.default.createElement(
													"ul",
													{ className: "rating reviews-item-header-rating-stars" },
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null),
													_react2.default.createElement("li", null)
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-rating-numbers" },
													_react2.default.createElement(
														"strong",
														null,
														"10"
													),
													"/10"
												)
											),
											_react2.default.createElement(
												"div",
												{ className: "reviews-item-header-writer" },
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-id" },
													"Writer's ID #19024*"
												),
												_react2.default.createElement(
													"span",
													{ className: "reviews-item-header-writer-registr" },
													"was registered in January 2014"
												)
											)
										),
										_react2.default.createElement(
											"div",
											{ className: "reviews-item-text" },
											_react2.default.createElement(
												"p",
												null,
												"The new bonus system is superb. Relying on the quality of work done, the levels of performance, and general customer satisfaction as the premises of determining the bonus is way better than what was utilized prior to the paradigm shift."
											)
										)
									)
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "col-md-4" },
								_react2.default.createElement(
									"div",
									{ id: "sidebar", className: "sidebar" },
									_react2.default.createElement(
										"div",
										{ id: "sidebar-scroll", className: "sidebar-scroll" },
										_react2.default.createElement(
											"div",
											{ className: "sidebar-img" },
											_react2.default.createElement("img", { src: _reviews2.default, alt: "Reviews Image" })
										)
									)
								)
							)
						)
					),
					_react2.default.createElement(
						"div",
						{ className: "inner-registration inner-registration-left" },
						_react2.default.createElement(
							"div",
							{ className: "container" },
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-image" },
								_react2.default.createElement(
									"div",
									{ className: "img inner-registration-img" },
									_react2.default.createElement("img", { src: _registerNowLeft2.default, alt: "Start registration" })
								)
							),
							_react2.default.createElement(
								"div",
								{ className: "inner-registration-text" },
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-title" },
									"Register now ",
									_react2.default.createElement("br", null),
									"to start earning!"
								),
								_react2.default.createElement(
									"div",
									{ className: "inner-registration-button" },
									_react2.default.createElement(
										_gatsbyLink2.default,
										{ to: "/register_email.html" },
										"Start registration"
									)
								)
							)
						)
					),
					_react2.default.createElement(_footer2.default, null)
				),
				_react2.default.createElement("div", { id: "mask", className: "c-mask" })
			);
		};
	
		return Reviews;
	}(_react2.default.Component);
	
	exports.default = Reviews;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-reviews-html-js-e3fa85f37718edb9d2fd.js